import { SavingTypes } from "../action/index.model";
import {
  SavingNameStateInterface,
  SavingNameTypeInterface,
} from "./index.model";

const initialState: SavingNameStateInterface = {
  loading: false,
  saved: false,
  updatedId: "",
  isError: false,
  currentEditingID: "",
  snackMessage: "",
};

const NumberCardReducer: any = (
  state: SavingNameStateInterface = initialState,
  action: SavingNameTypeInterface
) => {
  
  switch (action.type) {
    case SavingTypes.SET_EDITING_ID:
      return {
        ...state,
        currentEditingID: action.data.id,
      };
    case SavingTypes.UPDATE_LOADER:
      return {
        ...state,
        loading: action.data,
        currentEditingID: "",
      };
    case SavingTypes.GET_SAVING_NAME:
      return {
        ...state,
        loading: true,
      };
    case SavingTypes.UPDATE_SAVING_NAME:
      return {
        ...state,
        loading: true,
      };
    case SavingTypes.SAVING_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        snackMessage: action.data.message,
        saved: true,
        currentEditingID: "",
      };

    case SavingTypes.FAILURE_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        snackMessage: "",
        saved: false,
        currentEditingID: "",
        isError: action.data.isError,
      };
    case SavingTypes.UPDATED_NAME_ID:
      return {
        ...state,
        updatedId: action.data.id,
      };
    default:
      return state;
  }
};
export default NumberCardReducer;
